module.exports = __webpack_public_path__ + "static/media/main idea.f3fd8cb1.mp3";